(ns arthur.follow.party
  "Following someone, worked out from the presence roster. tl's parties, nearly
  line for line.

  The roster is a flat map of cid → {:cid :user :party :joinable}, gossiped over
  the project socket. A party is nothing but an id its members carry: nobody
  hosts one, you only follow someone into one. Following someone on their own
  adopts THEIR CID as the id, so two people following each other in the same
  instant land in the same party, and the party outlives whoever was followed
  first. Everyone in a party drives everyone else — a tab, a seek or a play from
  any member moves all the others — which is why being followed needs consent
  (`:joinable`), and why leaving is one click.

  Every peer computes the same answer from the same gossip, so the server never
  has to know any of it.")

(defn party-of [roster cid] (get-in roster [cid :party]))

(defn members
  "cids carrying party id `pid`. nil is not a party, so it has no members."
  [roster pid]
  (if pid
    (into #{} (keep (fn [[cid p]] (when (= pid (:party p)) cid))) roster)
    #{}))

(defn peers
  "The OTHER members of `cid`'s party."
  [roster cid]
  (disj (members roster (party-of roster cid)) cid))

(defn in-party?
  "A party id nobody else carries is not a party — a follow that went
  unanswered, or the last one left. Either way: on your own."
  [roster cid]
  (boolean (seq (peers roster cid))))

(defn join-id
  "The party id you take on by following `cid`: theirs if they are in one, else
  their own cid. Derived from the one followed rather than minted, which is what
  makes simultaneous follows converge on one party."
  [roster cid]
  (or (party-of roster cid) cid))

(defn joinable?
  "May `me` follow `cid`? Someone else, letting people follow, and not already
  in the party we are in."
  [roster me cid]
  (boolean (and me cid (not= me cid)
                (get-in roster [cid :joinable])
                (let [theirs (party-of roster cid)]
                  (or (nil? theirs) (not= theirs (party-of roster me)))))))

(defn mirrors?
  "Does `me` take a move broadcast by `sender`? Same party, different person."
  [roster me sender]
  (let [mine (party-of roster me)]
    (boolean (and me (not= me sender) mine (= mine (party-of roster sender))))))

(defn responder
  "The one member of `pid` who shows `newcomer` where the party is, so a follow
  draws one reply instead of one per member: the lowest cid among those already
  there. Deterministic, and still hostless — recomputed from whoever is present."
  [roster pid newcomer]
  (first (sort (disj (members roster pid) newcomer))))
